import React from "react"
import useRescuerRescues from "hooks/useRescuerRescues"
import Rescues from "components/rescue/Rescues"

export default function RescuerRescuesTab({username}) {

    const {data, isLoading} = useRescuerRescues(username)

    if (isLoading)
        return <div id="spinner" className="center"/>

    if (!Array.isArray(data))
        return <div className="info">{JSON.stringify(data)}</div>


    if (data.length === 0)
        return <div className="info">Nema povrednih listi</div>

    return <>
        <div className="mb-3">
            Broj povrednih listi kao vođa akcije: <strong>{data.length}</strong>
        </div>
        <Rescues rescues={data}/>
    </>
}
